import './LoadingIcon.less';

import React, {Component, useEffect, useState} from 'react';

import CeleryIcon from '../../../images/loading-icons/celery.svg';
import CornIcon from '../../../images/loading-icons/corn.svg';
import EggIcon from '../../../images/loading-icons/egg.svg';
import FishIcon from '../../../images/loading-icons/fish.svg';
import LupinIcon from '../../../images/loading-icons/lupin.svg';
import MilkIcon from '../../../images/loading-icons/milk.svg';
import MolluscsIcon from '../../../images/loading-icons/molluscs.svg';
import MushroomIcon from '../../../images/loading-icons/mushroom.svg';
import MustardIcon from '../../../images/loading-icons/mustard.svg';
import PeanutIcon from '../../../images/loading-icons/peanut.svg';
import SesameIcon from '../../../images/loading-icons/sesame.svg';
import ShellfishIcon from '../../../images/loading-icons/shellfish.svg';
import SoybeanIcon from '../../../images/loading-icons/soybean.svg';
import SulphitesIcon from '../../../images/loading-icons/sulphites.svg';
import TreenutsIcon from '../../../images/loading-icons/treenuts.svg';
import WheatIcon from '../../../images/loading-icons/wheat.svg';

const icons = [
	CeleryIcon,
	CornIcon,
	EggIcon,
	FishIcon,
	LupinIcon,
	MilkIcon,
	MolluscsIcon,
	MushroomIcon,
	MustardIcon,
	PeanutIcon,
	SesameIcon,
	ShellfishIcon,
	SoybeanIcon,
	SulphitesIcon,
	TreenutsIcon,
	WheatIcon,
];

function getRandomInt(min, max) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}

export const LoadingIcon = () => {
	const [step, setStep] = useState(getRandomInt(0, icons.length));

	useEffect(() => {
		const interval = setInterval(() => {
			setStep(getRandomInt(0, icons.length));
		}, 600);
		return () => {
			clearInterval(interval);
		};
	}, []);
	return (
		<div className={`loading-icon`}>
			{icons.map((icon, index) => {
				return (
					<div
						key={index}
						className="loading-icon__icon"
						style={{opacity: index === step ? 1 : 0}}
						dangerouslySetInnerHTML={{__html: icon}}
					/>
				);
			})}
		</div>
	);
};

